import { useContext, useState } from 'react';
import ContactSupplierService from '../../../../shared/services/contact-supplier/contact-supplier.service';
import { IContactSupplierDetails, IPostContactSupplier } from '../../../../shared/services/contact-supplier/contact-supplier.model';
import { SupplierForm } from '../../../presentation-components/organisation-components/supplier/supplier-form';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { useNavigate } from 'react-router-dom';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { ScreenLabelsContext } from '../../../../context/screen-labels/screen-labels';

export const OrganisationSupplierNewPage = () => {
  const navigate = useNavigate();
  //Services
  const contactSupplierService = ContactSupplierService.getInstance();
  const userNotificationsContext = useContext(UserNotificationsContext)
  const screenLabelsContext = useContext(ScreenLabelsContext)
  //State
  const [errorMessage, setErrorMessage] = useState<string>()
  const [errorCode, setErrorCode] = useState<number>()
  const [supplier, setSupplier] = useState<IContactSupplierDetails>()
  const [newSupplier, setNewSupplier] = useState<IPostContactSupplier>({
    id: '',
    name: '',
    additionalInformation: '',
    spendBasedConversionId: null,
    defaultSpendBasedConversionSourceId: '',
    primaryContactName: '',
    primaryContactEmail: '',
    contactSupplierReference: '',
    accreditations: [],
    otherAccreditationText: '',
    haveCarbonReductionTargets: false,
    customFieldValues: [],
    targetsVerified: false,
  })
  const [isFormSubmitting, setIsFormSubitting] = useState<boolean>(false)

  const submitHandler = async (newSupplierForm: IPostContactSupplier) => {
    if (!isFormSubmitting) {
      setIsFormSubitting(true)
      contactSupplierService.createSupplier(newSupplierForm)
        .then(response => {
          setIsFormSubitting(false)
          refreshSuppliers()
          navigate(`/organisation/suppliers/${response.id}`)
          userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' });
        })
        .catch(err => {
          setIsFormSubitting(false)
          console.log(err)
          if (err.response.data.message) {
            setErrorMessage(err.response.data.message)
            setErrorCode(err.response.data.code)
          } else {
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          }
        })
    } else {
      userNotificationsContext.openSnackbar({ open: true, message: 'Saving in progress, please wait' });
    }
  }

  function refreshSuppliers(): void {
    contactSupplierService.getAllSuppliers(true)
      .catch(err => {
        console.log(err)
      })
  }


  return (
    <PageOuterContainer>
      <PageHeading
        title={`Add New ${screenLabelsContext.getLabel('supplier', { plural: false, capitalize: 'first' })}`}
        includeBackButton={true}
        backButtonLink='/organisation/suppliers'
        backButtonText={`Back to ${screenLabelsContext.getLabel('supplier', { plural: true })}`}
      />
      <SupplierForm
        isSubmitting={isFormSubmitting}
        submitHandler={submitHandler}
        newSupplier={newSupplier}
        supplier={supplier}
        errorMessage={errorMessage}
        errorCode={errorCode}
        setErrorMessage={setErrorMessage}
        setErrorCode={setErrorCode}
      />
    </PageOuterContainer>
  )
}